module.exports = __webpack_public_path__ + "static/media/user_icon.01f67183.svg";